import { FC } from 'react';

import { useTranslation } from 'next-i18next/pages';

import { Button } from 'antd';

import { TranslationNamespace } from '@/i18n';

import styles from './DoYouHaveWarehouseBlock.module.scss';

export const DoYouHaveWarehouseBlock: FC = () => {
	const { t } = useTranslation(TranslationNamespace.WarehouseSearch);
	return (
		<div className={styles.container}>
			<div className={styles.title}>
				{t('warehouse-promotion.title')}
				<br />
				{t('warehouse-promotion.subtitle')}
			</div>
			<div className={styles.description}>{t('warehouse-promotion.description')}</div>
			<Button href="https://office.fishplace.ru/" className={styles.btn} block>
				{t('warehouse-promotion.action')}
			</Button>
		</div>
	);
};
